import React from 'react';
import { Typography } from '@material-ui/core';

import { PropsType } from 'components/Typography/types';
import styled from 'styled-components';

const StyledTypography = styled(({ color, weight, ...otherProps }) => (
  <Typography {...otherProps} />
))`
  font-weight: ${(props) => props.weight} !important;
  color: ${(props) => props.color} !important;
`;

const PageTitle = (props: PropsType) => {
  return (
    <StyledTypography variant="h1" {...props}>
      {props.children}
    </StyledTypography>
  );
};

export default PageTitle;
